import Start_Main_Start_Button from "./Start_Main_Start_Button";
import React from "react";

class Start_Main_Start_SignIn extends React.Component {
    render() {
        return(
            <div className="start_main_start_signIn">
                <h3 className="start_main_start_signIn_heading">Already have an account?</h3>
                <Start_Main_Start_Button text="Sign in" classButton="start_main_start_btnSignIn" classText="start_main_start_button_text_signIn" path="/start/signin"/>
            </div>
        )
    }
}

export default Start_Main_Start_SignIn;